<template>
  <Form :model="productItemData" :disabled="disabled">
    <Row :gutter="6">
      <Col span="11">
        <FormItem :label="$t('order.manufacturer_part')" prop="referenced_id" :rules="{ required: true, message: $t('order.manufacturer_part_is_required') }">
          <ManufacturerPartPicker
            ref="manufacturerPartPicker"
            v-model="productItemData.referenced_id"
            v-bind:manufacturer-part.sync="productItemData.referenced"
            :label="false">
          </ManufacturerPartPicker>
        </FormItem>
      </Col>
      <Col span="2">
        <FormItem :label="$t('order.additional_fee_qty')" prop="quantity" :rules="{ required: true, message: $t('order.additional_fee_qty_is_required') }">
          <InputNumber v-model="productItemData.quantity"></InputNumber>
        </FormItem>
      </Col>
      <Col span="3">
        <FormItem :label="$t('order.additional_fee_price')" prop="unit_price" :rules="{ required: true, message: $t('order.additional_fee_price_is_required') }">
          <InputNumber v-model="productItemData.unit_price"></InputNumber>
        </FormItem>
      </Col>
      <Col span="3">
        <FormItem :label="$t('order.additional_fee_cost')" prop="unit_cost">
          <InputNumber v-model="productItemData.unit_cost"></InputNumber>
        </FormItem>
      </Col>
      <Col span="4">
        <FormItem :label="$t('order.delivery_date')" prop="delivery_date" :rules="{ required: true, message: $t('order.additional_fee_delivery_date_is_required') }">
          <DatePicker
            v-model="productItemData.delivery_date"
            type="date"
            format="yyyy-MM-dd"
            @on-change="handleDateChange">
          </DatePicker>
        </FormItem>
      </Col>
      <Col span="1">
        <div style="line-height: 90px;">
          <Icon type="md-close" @click="handleDelete" />
        </div>
      </Col>
    </Row>
  </Form>
</template>

<script>
import moment from 'moment'
import { ManufacturerPartPicker } from '@/view/part/components'
import { mapActions } from 'vuex'
export default {
  name: "OrderAdditionalFeeProductItemForm",
  components: {
    ManufacturerPartPicker
  },
  props: {
    index: {
      type: [String, Number],
      required: false
    },
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.productItemData = this.data
  },
  data () {
    return {
      productItemData: {}
    }
  },
  methods: {
    ...mapActions(['deleteOrderChangeRecordItem']),
    handleDateChange (value) {
      this.productItemData.delivery_date = moment(value).format('YYYY-MM-DD')
    },
    handleDelete () {
      if (this.productItemData.id) {
        this.deleteOrderChangeRecordItem({ itemId: this.productItemData.id })
          .then(resp => {
            if (resp.data.success) {
              this.$emit('on-deleted', { itemId: this.productItemData.id, index: this.index, referencedType: 'manufacturer_part' })
            }
          })
      } else {
        this.$emit('on-deleted', { index: this.index })
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        if (this.data['delivery_date']) {
          this.data['delivery_date'] = moment(this.data['delivery_date']).format('YYYY-MM-DD')
        }
        this.productItemData = this.data
      }
    }
  }
}
</script>
